import { DOCUMENT } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { StorageService } from '../storage/storage.service';

@Injectable({
  providedIn: 'root',
})
export class LocalService extends StorageService {
  constructor() {
    const document = inject<Document>(DOCUMENT);
    let storage: Storage | undefined;
    try {
      // ponytail: ErrorHandler injection here would form a DI cycle via ErrorService -> SessionService
      storage = document.defaultView?.localStorage;
    } catch {
      storage = undefined;
    }
    super(storage);
  }
}
